module.exports = {
  // 服务器接口host, 跨域请求时设置
  apiHost: {
    // 开发环境
    // dev: 'https://zmbiz-outer-gateway-83-fat-alhz.inzm.com/',
    dev: 'https://zmbiz-outer-gateway-fat-alhz.inzm.com',
    // fat
    fat: 'https://zmbiz-outer-gateway-fat-alhz.inzm.com',
    // uat
    uat: 'https://zmbiz-outer-gateway-uat-alsh.inzm.com',
    // fat
    prod: 'https://cscportalweb.zmlearn.com',
  }[process.env.VUE_APP_RUN_ENV],

  // 项目部署的子路径，如应用被部署在 https://p-test.zmlearn.com/my-app，则设置为 /my-app
  publicPath: {
    // 开发环境
    development: '/',

    // fat/uat/prod环境
    production: '/',
  }[process.env.NODE_ENV],

  // 发布系统对应的应用ID，埋点使用
  appId: '11927',

  // 公众号id
  wechatId: {
    // 开发环境
    dev: {
      // 招聘圈
      recruitmentCircle: 'wx1416f052d8a4a2db',
      // 讲师平台
      lecturerPlatform: 'wx08f374bfd3994ce9',
    },
    // fat
    fat: {
      recruitmentCircle: 'wx1416f052d8a4a2db',
      lecturerPlatform: 'wx08f374bfd3994ce9',
    },
    // fat
    uat: {
      recruitmentCircle: '',
      lecturerPlatform: '',
    },
    // fat
    prod: {
      recruitmentCircle: 'wx7821432253bffdc5',
      lecturerPlatform: 'wx8541b713d7b75956',
    },
  }[process.env.VUE_APP_RUN_ENV],

  wechatName: {
    recruitmentCircle: '掌伊老师招聘圈',
    lecturerPlatform: '掌门讲师平台',
  },

  // 报名页地址
  signUrl: {
    // 开发环境
    dev: {
      // 全职报名页地址
      fullTimeUrl: 'http://b.zmlearn.com:8080/sign-up/pages?timeType=1',
      // 兼职报名页地址
      partTimeUrl: 'http://b.zmlearn.com:8080/sign-up/pages?timeType=0',
    },
    // fat
    fat: {
      fullTimeUrl: 'https://mobile-global-front.zmaxis.com/sign-up/pages?timeType=1',
      partTimeUrl: 'https://mobile-global-front.zmaxis.com/sign-up/pages?timeType=0',
    },
    // fat
    uat: {
      fullTimeUrl: 'https://wechat-teacherui-collection.uat.zmops.cc/sign-up/pages?timeType=1',
      partTimeUrl: 'https://wechat-teacherui-collection.uat.zmops.cc/sign-up/pages?timeType=0',
    },
    // fat
    prod: {
      fullTimeUrl: 'https://collection-h5.zmlearn.com/sign-up/pages?timeType=1',
      partTimeUrl: 'https://collection-h5.zmlearn.com/sign-up/pages?timeType=0',
    },
  }[process.env.VUE_APP_RUN_ENV],


  // 入职页地址
  entryUrl: {
    // 开发环境
    dev: 'http://zm-econtract-test.zmaxis.com/page/teacher/welcome',
    // fat
    fat: 'http://zm-econtract-test.zmaxis.com/page/teacher/welcome',
    // fat
    uat: 'http://zm-econtract.uat.zmops.cc/page/teacher/welcome',
    // fat
    prod: 'http://teacher-h5.zmlearn.com/page/teacher/welcome',
  }[process.env.VUE_APP_RUN_ENV],

  // 师资中心服务器接口地址
  teacherHost: {
    // 开发环境
    dev: 'http://10.111.239.47:8080',
    // fat
    fat: 'http://10.111.239.47:8080',
    // fat
    uat: 'http://172.31.118.243:8080',
    // fat
    prod: 'http://edu-admin-new.zhangmen.com',
  }[process.env.VUE_APP_RUN_ENV],

  // 接入H5登录页地址
  h5LoginUrl: {
    // 开发环境
    dev: 'http://zmbiz-general-h5-fat.zmaxis.com',
    // fat
    fat: 'http://zmbiz-general-h5-fat.zmaxis.com',
    // uat
    uat: 'http://zmbiz-general-h5-fat.zmaxis.com',
    // prod
    prod: 'https://zmbiz-general-h5.zmaxis.com',
  }[process.env.VUE_APP_RUN_ENV],

  // 埋点标记
  burryEvent: {
    teaAgent: {
      // 老推荐有奖跳转统计
      oldTeaAgentBurry: '10000',
      // 点击立即邀请
      click_1d1_invite: 'click_1d1_invite',
      // 点击推荐规则
      click_1d1_rule: 'click_1d1_rule',
      // 点击推荐攻略
      click_1d1_suggest: 'click_1d1_suggest',
      // 点击补充信息
      click_1d1_info: 'click_1d1_info',
    },
    signUp: {
      // 点击求职类型
      click_1d1_teatype: 'click_1d1_teatype',
      // 点击学段学科
      click_1d1_phase: 'click_1d1_phase',
      // 点击点击姓名栏
      click_1d1_name: 'click_1d1_name',
      // 点击手机号栏
      click_1d1_tel: 'click_1d1_tel',
      // 手机号弹窗点击下一步
      click_1d1_telnext: 'click_1d1_telnext',
      // 手机号弹窗校验验证码
      click_1d1_telcheck: 'click_1d1_telcheck',
      // 点击微信栏
      click_1d1_wechat: 'click_1d1_wechat',
      // 点击邮箱栏
      click_1d1_mail: 'click_1d1_mail',
      // 点击qq栏
      click_1d1_qq: 'click_1d1_qq',
      // 点击学历栏
      click_1d1_degree: 'click_1d1_degree',
      // 点击学校栏
      click_1d1_school: 'click_1d1_school',
      // 点击入学毕业时间
      click_1d1_graduatedate: 'click_1d1_graduatedate',
      // 点击教资栏
      click_1d1_certificate: 'click_1d1_certificate',
      // 点击学科阶段
      click_1d1_certificateperiod: 'click_1d1_certificateperiod',
      // 点击学科科目
      click_1d1_certificatesubject: 'click_1d1_certificatesubject',
      // 点击优势栏
      click_1d1_advantage: 'click_1d1_advantage',
      // 点击推荐人栏
      click_1d1_introduce: 'click_1d1_introduce',
      // 点击立即报名
      click_1d1_submit: 'click_1d1_submit',
    },
  },

};
